<!--  -->
<template>
  <div>
    <el-form label-position="right" label-width="90px" :model="formLabelAlign">
      <el-form-item label="选择企业">
        <el-tag v-if="formLabelAlign.corpid!=''" style="margin-right:10px">{{ name }} ({{ formLabelAlign.corpid }}) </el-tag>
        <el-button type="primary" size="mini" @click="choose">选择企业</el-button>
      </el-form-item>
      <el-form-item label="服务商员工购买人">
        <el-select v-model="formLabelAlign.buyer_userid" placeholder="请选择服务商员工购买人">
          <el-option
            v-for="item in options"
            :key="item.userid"
            :label="item.userid"
            :value="item.userid"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-radio-group v-model="radio" size="small" @change="darwr">
          <el-radio-button :label="1">基础帐号个数</el-radio-button>
          <el-radio-button :label="2">互通帐号个数</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="radio == 1" label="基础帐号个数">
        <el-input-number v-model="formLabelAlign.base_count" :min="0" />
      </el-form-item>
      <el-form-item v-if="radio == 2" label="互通帐号个数">
        <el-input-number v-model="formLabelAlign.external_contact_count" :min="0" />
      </el-form-item>
      <el-form-item>
        <el-radio-group v-model="radiotwo" size="small" @change="darwrr">
          <el-radio-button :label="1">购买的月数</el-radio-button>
          <el-radio-button :label="2">购买的天数</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="radiotwo == 1" label="购买的月数">
        <el-input-number v-model="formLabelAlign.months" :min="1" :max="60" />
      </el-form-item>
      <el-form-item v-if="radiotwo == 2" label="购买的天数">
        <el-input-number v-model="formLabelAlign.days" :min="31" :max="1860" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbitr">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择企业"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      width="60%"
    >
      <enterprise @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
import enterprise from '../../behavioralsource/components/enterprise.vue'
import { accountAccesslistProviderUsers, spaccountAccessindex } from '@/api/officialaccount.js'
export default {
  components: { enterprise },
  data() {
    return {
      dialogVisible: false,
      name: '',
      formLabelAlign: {
        corpid: '',
        buyer_userid: null,
        base_count: 0,
        external_contact_count: 0,
        months: 0,
        days: 0
      },
      options: [
        {
          userid: 4,
          department: 74
        }
      ],
      radio: 1,
      radiotwo: 1
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send() {
      console.log('111')
      this.list()
    },

    async list() {
      const data = await accountAccesslistProviderUsers()
      this.options = data.data
      console.log('data', data)
    },
    async sumbitr() {
      if (this.formLabelAlign.corpid === '') {
        this.$message.error('请选择企业')
        return
      }
      if (this.formLabelAlign.buyer_userid === null) {
        this.$message.error('请选择服务商员工购买人')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.radio == 1) {
        if (this.formLabelAlign.base_count === undefined) {
          this.$message.error('请输入基础帐号个数')
          return
        }
      } else {
        if (this.formLabelAlign.external_contact_count === undefined) {
          this.$message.error('请输入互通帐号个数')
          return
        }
      }
      // eslint-disable-next-line eqeqeq
      if (this.radiotwo == 1) {
        if (this.formLabelAlign.months === undefined) {
          this.$message.error('请输入购买的月数')
          return
        }
      } else {
        if (this.formLabelAlign.days === undefined) {
          this.$message.error('请输入购买的天数')
          return
        }
      }
      const data = await spaccountAccessindex(this.formLabelAlign)
      this.$emit('updata')
      console.log('data', data)
      console.log('this.formLabelAlign.base_count', this.formLabelAlign.base_count)
    },
    callback(item) {
      // console.log(item)
      this.dialogVisible = false
      this.name = item.corp_name
      this.formLabelAlign.corpid = item.corp_id
    },
    choose() {
      this.dialogVisible = true
    },
    darwr(val) {
      // eslint-disable-next-line eqeqeq
      if (val == 1) {
        this.formLabelAlign.external_contact_count = 0
      } else {
        this.formLabelAlign.base_count = 0
      }
    },
    darwrr(val) {
      // eslint-disable-next-line eqeqeq
      if (val == 1) {
        this.formLabelAlign.days = 0
      } else {
        this.formLabelAlign.months = 0
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
